import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MergeBackfillRunFragment = { __typename?: 'MergeBackfillRun', id: number, createdAt: string, updatedAt: string, queuedAt?: string | null, startedAt?: string | null, completedAt?: string | null, isNightlyResync?: boolean | null, modifiedActiveEmployeesCount: number, hrisIntegration: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } };

export type MergeBackfillRunsQueryVariables = Types.Exact<{
  input: Types.MergeBackfillRunsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type MergeBackfillRunsQuery = { __typename?: 'Query', MergeBackfillRuns: { __typename?: 'MergeBackfillRuns', totalCount: number, objects: Array<{ __typename?: 'MergeBackfillRun', id: number, createdAt: string, updatedAt: string, queuedAt?: string | null, startedAt?: string | null, completedAt?: string | null, isNightlyResync?: boolean | null, modifiedActiveEmployeesCount: number, hrisIntegration: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } }> } };

export const MergeBackfillRunFragmentDoc = gql`
    fragment MergeBackfillRun on MergeBackfillRun {
  id
  createdAt
  updatedAt
  queuedAt
  startedAt
  completedAt
  isNightlyResync
  modifiedActiveEmployeesCount
  hrisIntegration {
    id
    hrisProvider
  }
}
    `;
export const MergeBackfillRunsDocument = gql`
    query MergeBackfillRuns($input: MergeBackfillRunsInput!, $pagination: PaginationInput) {
  MergeBackfillRuns(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...MergeBackfillRun
    }
  }
}
    ${MergeBackfillRunFragmentDoc}`;

/**
 * __useMergeBackfillRunsQuery__
 *
 * To run a query within a React component, call `useMergeBackfillRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeBackfillRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeBackfillRunsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMergeBackfillRunsQuery(baseOptions: Apollo.QueryHookOptions<MergeBackfillRunsQuery, MergeBackfillRunsQueryVariables> & ({ variables: MergeBackfillRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MergeBackfillRunsQuery, MergeBackfillRunsQueryVariables>(MergeBackfillRunsDocument, options);
      }
export function useMergeBackfillRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MergeBackfillRunsQuery, MergeBackfillRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MergeBackfillRunsQuery, MergeBackfillRunsQueryVariables>(MergeBackfillRunsDocument, options);
        }
export type MergeBackfillRunsQueryHookResult = ReturnType<typeof useMergeBackfillRunsQuery>;
export type MergeBackfillRunsLazyQueryHookResult = ReturnType<typeof useMergeBackfillRunsLazyQuery>;
export type MergeBackfillRunsQueryResult = Apollo.QueryResult<MergeBackfillRunsQuery, MergeBackfillRunsQueryVariables>;